module.exports = __webpack_public_path__ + "static/Glia-9f24990a579dad34910c84ae8e38926b.jpg";